export default __webpack_public_path__ + "static/phone-screen-mb-fabb6f93b1c1ef65de954412edfbc94d.webp";